import { render, staticRenderFns } from "./BaseModalIntro.vue?vue&type=template&id=37fd1a8a"
import script from "./BaseModalIntro.vue?vue&type=script&lang=js"
export * from "./BaseModalIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports